import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface DepositState {
    amount: number;
    percent: number;
    period: number;
    daysInMonth: number;
    daysInYear: number;
    depositInterestTotal: number;
    depositTotalAmount: number;
    averageDepositReward: number;
    interests: {
        period: number;
        interestSum: number;
        amount: number;
    }[]
}

const initialState: DepositState = {
    amount: 0,
    percent: 0,
    period: 1,
    daysInMonth: 30,
    daysInYear: 360,
    depositInterestTotal: 0,
    depositTotalAmount: 0,
    averageDepositReward: 0,
    interests: []
} 

const depositSlice = createSlice({
    name: 'deposit',
    initialState,
    reducers: {
        setDepositData(state, action: PayloadAction<DepositState>) {
            state.amount = Number(action.payload.amount);
            state.percent = Number(action.payload.percent);
            state.period = Number(action.payload.period);
            state.daysInMonth = Number(action.payload.daysInMonth);
            state.daysInYear = Number(action.payload.daysInYear);
            state.depositInterestTotal = Number(action.payload.depositInterestTotal);
            state.depositTotalAmount = Number(action.payload.depositTotalAmount);
            state.averageDepositReward = Number(action.payload.averageDepositReward);
            state.interests = action.payload.interests;
        },
        resetDepositData(state) {
            state.amount = 0;
            state.percent = 0;
            state.period = 0;
            state.daysInMonth = 30;
            state.daysInYear = 360;
            state.depositInterestTotal = 0;
            state.depositTotalAmount = 0;
            state.averageDepositReward = 0;
            state.interests = [];
        }
    }
})

export const { setDepositData, resetDepositData } = depositSlice.actions
export default depositSlice.reducer;